import React, { useState, useEffect } from "react";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
export default function CaseDisplay() {
    return (
        <Stack spacing={1}>
            <br />
            <Typography variant="subtitle2">Joe Smith vs Jane Doe</Typography>
            <Typography variant="subtitle2">2025-SC-00123</Typography>
            <Typography variant="subtitle2">EFME-300012</Typography>
        </Stack>
    );
}
